import React, {useState} from 'react';
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import {toast} from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {Link, useNavigate} from "react-router-dom";
import { Spinner } from 'react-bootstrap';

import './style.scss';
import { useForgotPasswordMutation } from '../../api/accountApi';

const ForgotPassword = (props) => {

    const push = useNavigate()
    const [sendForgotPasswordEmail] = useForgotPasswordMutation();
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState({
        email: '',
    });

    const changeHandler = (e) => {
        setValue({...value, [e.target.name]: e.target.value});
        validator.showMessages();
    };

    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));



    const submitForm = async (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setLoading(true);
            
            try {
                const response = await sendForgotPasswordEmail(value.email);
                
                if (response.data && response.data.isSuccess) {
                    toast.success(response.data.messages?.[0] || 'Verification code sent to your email!');
                    validator.hideMessages();
                    setTimeout(() => {
                        push(`/verify-digit/${value.email}`);
                    }, 1000);
                } else {
                    toast.error(response.data?.errorMessages?.[0] || 'Failed to send verification code');
                    setLoading(false);
                }
            } catch (error) {
                toast.error('An error occurred. Please try again.');
                setLoading(false);
            }
        } else {
            validator.showMessages();
            toast.error('Please enter a valid email address!');
        }
    };
    return (
        <Grid className="loginWrapper">

            <Grid className="loginForm">
                <h2>Forgot Password</h2>
                <p>Reset your account password</p>
                <form onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="E-mail"
                                value={value.email}
                                variant="outlined"
                                name="email"
                                label="E-mail"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('email', value.email, 'required|email')}
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className="formFooter">
                                <Button fullWidth className="cBtn cBtnLarge cBtnTheme" type="submit" disabled={loading}>
                                    {loading ? <><Spinner animation="border" size="sm" /> Sending...</> : 'Send Verification Code'}
                                </Button>
                            </Grid>
                           
                            <p className="noteHelp">Already have an account? <Link to="/login">Return to Sign In</Link>
                            </p>
                        </Grid>
                    </Grid>
                </form>
                <div className="shape-img">
                    <i className="fi flaticon-honeycomb"></i>
                </div>
            </Grid>
        </Grid>
    )
};

export default ForgotPassword;